export const validCredentialsB05 = [
   
    

      { expirationDate:"Acceso Ilimitado",nivel:"premium",usuario: 'lia', password: 'adriana', realname: 'Prueba Gratuita', img: 'https://i.ibb.co/chn6rvR/Dise-o-sin-t-tulo-3.png' }, // No image

    
    ];
